export default __webpack_public_path__ + "media/images/elephant_ui_plane-b42d0c22323e622c5b055d7df11fe581.svg";